import { defineStore } from 'pinia'
import baseService from '@/utils/http/axios'

export type ArtistStatus = 0 | 1 | 2
export type ExhibitionFlag = 0 | 1

export interface ArtistListItem {
  id: string | number
  cover: string
  name: string
  subText: string
  status: ArtistStatus
  currentExhibition: ExhibitionFlag
  createTime: string
}

export interface ArtistDetail {
  id: string | number
  cover: string
  name: string
  subText: string
  introContent: string
  worksContent: string
  currentExhibition: ExhibitionFlag
  status: ArtistStatus
}

export interface ArtistPageParams {
  pageNum: number
  pageSize: number
  artistName?: string
  status?: ArtistStatus
  currentExhibition?: ExhibitionFlag
}

export interface ArtistSavePayload {
  id?: string
  cover: string
  name: string
  subText: string
  introContent: string
  worksContent: string
  currentExhibition: ExhibitionFlag
  publish: boolean
}

export const useArtist = defineStore('artist', {
  state: () => ({}),
  actions: {
    async getArtistPage(params: ArtistPageParams) {
      const res: any = await baseService({
        url: '/console/art/artist/page',
        method: 'get',
        params
      })
      return res.data
    },

    async getArtistInfo(id: string | number) {
      const res: any = await baseService({
        url: `/console/art/artist/info/${id}`,
        method: 'get'
      })
      return res.data as ArtistDetail
    },

    async saveArtist(data: ArtistSavePayload) {
      const res: any = await baseService({
        url: '/console/art/artist/save',
        method: 'post',
        data
      })
      return res.data
    },

    async deleteArtist(id: string | number) {
      const res: any = await baseService({
        url: '/console/art/artist/del',
        method: 'post',
        data: { id: String(id) }
      })
      return res.data
    },

    async changeArtistStatus(id: string | number, status: 1 | 2) {
      const res: any = await baseService({
        url: '/console/art/artist/changeStatus',
        method: 'post',
        data: { id: String(id), status }
      })
      return res.data
    },

    async changeArtistExhibition(id: string | number, currentExhibition: ExhibitionFlag) {
      const res: any = await baseService({
        url: '/console/art/artist/changeExhibition',
        method: 'post',
        data: { id: String(id), currentExhibition }
      })
      return res.data
    }
  }
})
